"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _store = require("../../redux/store");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _GracePeriodErrorStyled = require("./GracePeriodErrorStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var AlertIcon = function AlertIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M23.077 12.372a11.057 11.057 0 0 1-10.938 11.172A11.057 11.057 0 0 1 1.2 12.372 11.057 11.057 0 0 1 12.139 1.2a11.057 11.057 0 0 1 10.938 11.172Z",
        fill: "none",
        stroke: "#e66370",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2.4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12.139 13.572a1.2 1.2 0 0 1-1.2-1.2V7.663a1.2 1.2 0 0 1 2.4 0v4.709a1.2 1.2 0 0 1-1.2 1.2Z",
        fill: "#e66370"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12.139 16.841h0",
        fill: "none",
        stroke: "#e66370",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2.4"
      })]
    })
  });
};
AlertIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.277",
  height: "24.744"
};
const GracePeriodError = () => {
  const dispatch = (0, _store.useAppDispatch)();
  const {
    data: currentPlan
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectCurrentPlan);
  const displayGracePeriodError = (0, _store.useAppSelector)(_publisherConfigSlice.selectDisplayGracePeriodError);
  (0, _react.useEffect)(() => {
    if (displayGracePeriodError && currentPlan.length === 0) {
      dispatch((0, _planDetailsSlice.fetchCustomerOffers)());
    }
  }, [displayGracePeriodError]);
  const isPeriodError = displayGracePeriodError && (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.some(_ref => {
    let {
      status,
      expiresAt
    } = _ref;
    return status === 'active' && new Date(expiresAt * 1000) < new Date();
  }));
  if (!isPeriodError) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_GracePeriodErrorStyled.GracePeriodErrorStyled, {
    "data-testid": "grace-period-error",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GracePeriodErrorStyled.IconStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertIcon, {
        "data-testid": "alert-svg"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
        i18nKey: "grace-period-error",
        children: ["Your subscription couldn't be renewed due to a payment method issue. Please ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_GracePeriodErrorStyled.WarningMessageStyled, {
          children: "update it"
        }), ' ', "to avoid losing access to the content."]
      })
    })]
  });
};
var _default = exports.default = GracePeriodError;